

$(document).ready(function () {
  

//     setTimeout(function() {
//       console.log('Running code'); 

//       $('ul.rebuy-cart__flyout-items li').each(function(index) {
//         var compare_price = parseFloat($('#cst-smartcart-' + index + ' span.rebuy-money.compare-at span.cart-rebuy-money').text());
//         var original_price = parseFloat($('#cst-smartcart-' + index + ' span.rebuy-money.sale span.cart-rebuy-money').text());
//         if(compare_price != 0){  
// console.log('hai');
//         var price_difference = compare_price - original_price;
//         var percentage_difference = (price_difference / compare_price) * 100;

//         console.log('Compare Price:', compare_price);
//         console.log('Original Price:', original_price);
//         console.log('Price Difference:', price_difference);
//         console.log('Percentage Difference:', Math.floor(percentage_difference) + '% off');
//         console.log('------------------');
//         $('#cst-smartcart-' + index + ' .cartDiscountInfo').html(Math.floor(percentage_difference) + '% off');
//         $('#cst-smartcart-' + index + ' .cartDiscountInfo').addClass('product-badge');
//  }
        
//       });
//     }, 5000);

//$("body").on('DOMSubtreeModified', "#rebuy-cart .rebuy-cart__flyout-content", function() {
$(document).on('click', '.cst-btnbtn', function() {
  setTimeout(function() {
      // console.log('Running code');
      $('ul.rebuy-cart__flyout-items li').each(function(index) {
        var compare_price = parseFloat($('#cst-smartcart-' + index + ' span.cst-compare-price').text());
        var original_price = parseFloat($('#cst-smartcart-' + index + ' span.cst-original-price').text());
        if(compare_price == 0){
          // console.log('not compare price found');
        }else{
          // console.log('compare price found');
          var price_difference = compare_price - original_price;
          var percentage_difference = (price_difference / compare_price) * 100;
          // console.log('Compare Price:', compare_price);
          // console.log('Original Price:', original_price);
          // console.log('Price Difference:', price_difference);
          // console.log('Percentage Difference:', Math.floor(percentage_difference) + '% off');
          // console.log('------------------');
          $('#cst-smartcart-' + index + ' .cartDiscountInfo').html(Math.floor(percentage_difference) + '% off');
          $('#cst-smartcart-' + index + ' .cartDiscountInfo').addClass('product-badge');
       }
     });
  }, 3000);
});
  // $("body").on('DOMSubtreeModified', "#rebuy-cart .rebuy-cart__flyout-content", function() {
  //   console.log('changed');
  //   setTimeout(function() {
  //     console.log('Running code');
  //     $('ul.rebuy-cart__flyout-items li').each(function(index) {
  //       var compare_price = parseFloat($('#cst-smartcart-' + index + ' span.cst-compare-price').text());
  //       var original_price = parseFloat($('#cst-smartcart-' + index + ' span.cst-original-price').text());
  //       if(compare_price){
  //         console.log('hai');
  //       var price_difference = compare_price - original_price;
  //       var percentage_difference = (price_difference / compare_price) * 100;

  //       console.log('Compare Price:', compare_price);
  //       console.log('Original Price:', original_price);
  //       console.log('Price Difference:', price_difference);
  //       console.log('Percentage Difference:', Math.floor(percentage_difference) + '% off');
  //       console.log('------------------');
  //       $('#cst-smartcart-' + index + ' .cartDiscountInfo').html(Math.floor(percentage_difference) + '% off');
  //       $('#cst-smartcart-' + index + ' .cartDiscountInfo').addClass('product-badge');
  //         }
        
  //     });
  //   }, 1000);
  // });
// setTimeout(function(){
//       if($('#rebuy-cart .rebuy-cart__flyout-content').hasClass('no-items')){
//        console.log('asdasd');
//       var textcartnew = $(document).find('.collectionscarts').html();
//      //console.log(textcartnew);
//        $(document).find('.collectionscartnew').html(textcartnew);
//         }
//       else{
//         var slidernew = $(document).find('.slider-with-item').html();
//            $(document).find('.slider-with-item-new').html(slidernew);
//         $('#slick-slide-control81').trigger('click');
//       }
//         }, 6000);
  
  setTimeout(function(){
        var textcartnew = $(document).find('.collectionscarts').html();
        // console.log('added html');
        $(document).find('.collectionscartnew').html('<a href="/collections/braxley-best-sellers"><div class="col-csrt A1"><img src="//braxleybands.com/cdn/shop/files/IMG_4587-compressed_1_small.jpg?v=1686057951"><h3>shop best sellers</h3></div></a><a href="/collections/apple-watch-bands"><div class="col-csrt A2"><img src="//cdn.shopify.com/s/files/1/0017/2841/3740/files/ash-apple-watch-bands-braxley-bands-4_small.jpg?v=1770756629" width="100" height="100" loading="lazy"><h3>SHOP APPLE WATCH BANDS</h3></div></a><a href="/collections/belt-bags"><div class="col-csrt A3"><img src="//braxleybands.com/cdn/shop/files/DSC_2979_1-compressed_small.jpg?v=1683030554"><h3>SHOP BELTS &amp; BAGS</h3></div></a><div class="fetaures"><div class="feature-crt"><img src="//braxleybands.com/cdn/shop/files/icon-new-tree_dc9c97b7-b7cb-43c8-a7fc-065555e79e43_1_small.jpg?v=1690382682"><h3>1 ITEM SOLD = 1 TREE PLANTED</h3></div><div class="feature-crt"><img src="//braxleybands.com/cdn/shop/files/truck-delivered-icon_1_small.png?v=1690382622"><h3>SHIPS FAST FROM BRAXLEY HQ</h3></div><div class="feature-crt"><img src="//braxleybands.com/cdn/shop/files/unnamed.png?v=1689773394" alt=""><h3>30 DAYS RETURNS</h3></div></div><div class="carsjopbtn"><a href="/collections">SHOP ALL PRODUCTS</a><h2>TRY ONE RISK FREE!</h2></div>');
  }, 5800);      
  setTimeout(function(){
       var slidernew = $(document).find('.slider-with-item').html();
       // console.log('added html of slider');
       $(document).find('.slider-with-item-new').html(slidernew);
       $('#slick-slide-control81').trigger('click');
   }, 6000);
  
$(document).on('click', '.remove__btn', function(){
  setTimeout(function(){
      if($('#rebuy-cart .rebuy-cart__flyout-content').hasClass('no-items')){
          // console.log('remove html');
          var textcartnew = $(document).find('.collectionscarts').html();
          $(document).find('.collectionscartnew').html('<a href="/collections/braxley-best-sellers"><div class="col-csrt A1"><img src="//braxleybands.com/cdn/shop/files/IMG_4587-compressed_1_small.jpg?v=1686057951"><h3>shop best sellers</h3></div></a><a href="/collections/apple-watch-bands"><div class="col-csrt A2"><img src="//cdn.shopify.com/s/files/1/0017/2841/3740/files/ash-apple-watch-bands-braxley-bands-4_small.jpg?v=1770756629" width="100" height="100" loading="lazy"><h3>SHOP APPLE WATCH BANDS</h3></div></a><a href="/collections/belt-bags"><div class="col-csrt A3"><img src="//braxleybands.com/cdn/shop/files/DSC_2979_1-compressed_small.jpg?v=1683030554"><h3>SHOP BELTS &amp; BAGS</h3></div></a><div class="fetaures"><div class="feature-crt"><img src="//braxleybands.com/cdn/shop/files/icon-new-tree_dc9c97b7-b7cb-43c8-a7fc-065555e79e43_1_small.jpg?v=1690382682"><h3>1 ITEM SOLD = 1 TREE PLANTED</h3></div><div class="feature-crt"><img src="//braxleybands.com/cdn/shop/files/truck-delivered-icon_1_small.png?v=1690382622"><h3>SHIPS FAST FROM BRAXLEY HQ</h3></div><div class="feature-crt"><img src="//braxleybands.com/cdn/shop/files/unnamed.png?v=1689773394" alt=""><h3>30 DAYS RETURNS</h3></div></div><div class="carsjopbtn"><a href="/collections">SHOP ALL PRODUCTS</a><h2>TRY ONE RISK FREE!</h2></div>');
      }
  }, 6200); 
});
 //  $("body").on('DOMSubtreeModified', "#rebuy-cart .rebuy-cart__flyout-content", function() {
 //     console.log('changed');

 //  var slidernew = $(document).find('.slider-with-item').html();
 //        $(document).find('.slider-with-item-new').html(slidernew);


 //        var textcartnew = $(document).find('.collectionscarts').html();
 //       $(document).find('.collectionscartnew').html(textcartnew);
 
 // });


  $(".megamenu-dropdown-btn").click(function () {
    $(this).closest(".mobile-menu-item").toggleClass("open");
    this.setAttribute("aria-expanded", $(this).closest(".mobile-menu-item").hasClass("open") ? "true" : "false");

    // flip the clicked item

    $(this).toggleClass("open");

    // animate a child of the parent to slide down. The parent is not the immediate parent though

    $(this)
      .closest(".mobile-menu-item")
      .children(".mobile-megamenu-dropdown")
      .slideToggle(300);
  });

  

  // $(".js-product-carousel-2").slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   dots: true,
  //   infinite: false,
  //   speed: 500,
  //   cssEase: "ease",
  //   fade: true,
  //   responsive: [
  //     {
  //       breakpoint: 9999,
  //       settings: { dots: false, slidesToScroll: 1 },
  //     },
  //     {
  //       breakpoint: 1088,
  //       dots: true,
  //       settings: { slidesToShow: 1, slidesToScroll: 1 },
  //     },
  //   ],
  // });

});
// document.addEventListener('DOMContentLoaded', function() {
//     var button = document.getElementById('rewardbtn');
//     var tab = document.getElementById('rew-wrapper');

//     button.addEventListener('click', function() {
//         this.classList.toggle('active');
//     });
// });

